import { faApple } from "@fortawesome/free-brands-svg-icons/faApple";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const Apple: FC<
  JSX.IntrinsicAttributes & Omit<FontAwesomeIconProps, "icon">
> = (props) => {
  return <FontAwesomeIcon icon={faApple} {...props} />;
};
